$(document).ready(function () {
  // Variables store front access token and URL
  var storeFrontAccessToken = "412fe2d9cd8c3f9f050077edaf45b0fc";
  var storeFrontApiURL = "http://uk.justhype.com/api/2023-01/graphql.json";
  var customerEmail;
  var customerPassword;

  // Function of getting ID and password from login page
  $("#customer_login").submit(function () {
    // Variables to store ID and password from login page
    customerEmail = $("#CustomerEmail").val();
    customerPassword = $("#CustomerPassword").val();

    // Function call of customer access token mutation
    Mutations();
  });

  // Function of getting ID and password from register page
  $("#create_customer").submit(function () {
    // Variables to store ID and password from register page
    customerEmail = $("#RegisterForm-email").val();
    customerPassword = $("#RegisterForm-password").val();

    // Function call of customer access token mutation
    Mutations();
  });

  // Function to create customer access token mutation
  function Mutations() {
    var formInput = {
      input: {
        email: customerEmail,
        password: customerPassword,
      },
    };

    var requestBody = {
      query:
        "mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) { customerAccessTokenCreate(input: $input) { customerAccessToken{ accessToken expiresAt } customerUserErrors{ code field message } } }",
      variables: {
        input: formInput.input,
      },
    };

    var oReq = new XMLHttpRequest();
    oReq.open("POST", storeFrontApiURL);
    oReq.responseType = "json";
    oReq.setRequestHeader(
      "X-Shopify-Storefront-Access-Token",
      storeFrontAccessToken
    );
    oReq.setRequestHeader("Content-Type", "application/json");
    oReq.onload = function (e) {
      var xhr = e.target;

      // Used local storage to store customer access token
      localStorage.setItem(
        "CustomerToken",
        xhr.response.data.customerAccessTokenCreate.customerAccessToken
          .accessToken
      );

      // Customer token expire date
      localStorage.setItem(
        "CustomerTokenExpiresAt",
        xhr.response.data.customerAccessTokenCreate.customerAccessToken
          .expiresAt
      );
    };
    oReq.send(JSON.stringify(requestBody));
  }

  var currentDate = new Date().toISOString().split("T")[0];

  // Function to edit customer details using access token and update mutation
  $("#customer-detail").submit(function (e) {
    e.preventDefault();
    var Exp = localStorage.getItem("CustomerTokenExpiresAt");
    var Token = localStorage.getItem("CustomerToken");
    var href = "https://uk.justhype.com/account/logout";
    var currentDate = new Date().toISOString().split("T")[0];

    if (Token == null || Exp == currentDate) {
      window.location.href = href;
    } else {
      var customerFirstName = $("#customerFirstName").val();
      var customerLastName = $("#customerLastName").val();
      var customerEmail = $("#customerEmail").val();
      //       var customerNumber = $('#customerNumber').val();

      var requestBody2 = {
        query:
          "mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) { customer { displayName }customerAccessToken { accessToken expiresAt }customerUserErrors { code field message }}}",
        variables: {
          customer: {
            firstName: customerFirstName,
            lastName: customerLastName,
            email: customerEmail,
            //             "phone": customerNumber
          },
          customerAccessToken: Token,
        },
      };
      var oReq = new XMLHttpRequest();
      oReq.open("POST", storeFrontApiURL);
      oReq.responseType = "json";
      oReq.setRequestHeader(
        "X-Shopify-Storefront-Access-Token",
        storeFrontAccessToken
      );
      oReq.setRequestHeader("Content-Type", "application/json");
      oReq.onload = function (e) {
        var vhr = e.target;
        if ($(".acc-bar .customer_detail").hasClass("active")) {
          localStorage.setItem("activeTab", "customer_detail");
        }

        location.reload();
      };
      oReq.send(JSON.stringify(requestBody2));
    }
  });
  $("#customer-Number").submit(function (e) {
    e.preventDefault();
    var Exp = localStorage.getItem("CustomerTokenExpiresAt");
    var Token = localStorage.getItem("CustomerToken");
    var href = "https://uk.justhype.com/account/logout";
    var currentDate = new Date().toISOString().split("T")[0];

    console.log(currentDate);
    if (Token == null || Exp == currentDate) {
      window.location.href = href;
    } else {
      var customerFirstName = $("#customerFirstName").val();
      var customerLastName = $("#customerLastName").val();
      var customerEmail = $("#customerEmail").val();
      var customerNumber = $("#customerNumber").val();

      var requestBody2 = {
        query:
          "mutation customerUpdate($customer: CustomerUpdateInput!, $customerAccessToken: String!) {customerUpdate(customer: $customer, customerAccessToken: $customerAccessToken) { customer { displayName }customerAccessToken { accessToken expiresAt }customerUserErrors { code field message }}}",
        variables: {
          customer: {
            firstName: customerFirstName,
            lastName: customerLastName,
            email: customerEmail,
            phone: customerNumber,
          },
          customerAccessToken: Token,
        },
      };
      var oReq = new XMLHttpRequest();
      oReq.open("POST", storeFrontApiURL);
      oReq.responseType = "json";
      oReq.setRequestHeader(
        "X-Shopify-Storefront-Access-Token",
        storeFrontAccessToken
      );
      oReq.setRequestHeader("Content-Type", "application/json");
      oReq.onload = function (e) {
        var vhr = e.target;
        if ($(".acc-bar .customer_detail").hasClass("active")) {
          localStorage.setItem("activeTab", "customer_detail");
        }

        location.reload(true);
      };
      oReq.send(JSON.stringify(requestBody2));
    }
  });

  //     if (!$(".acc-bar .customer_detail").hasClass("active")) {
  //       localStorage.removeItem("activeTab");
  //     }
  var activeTab = localStorage.getItem("activeTab");
  if (activeTab) {
    $(".acc-bar .bar-item").removeClass("active");
    $(".acc-container").hide();
    $("." + activeTab).addClass("active");
    $("#" + activeTab).show();
    $("." + activeTab).show();
  }

  $(".acc-bar .bar-item").on("click", function () {
    localStorage.removeItem("activeTab");
  });
});
